<style src="./FisicalFormSelector.scss" lang="scss" scoped></style>
<template>
  <ul class="fisical-form-selector">
    <li
      class="formitem"
      v-for="(item, idx) in list"
      :key="idx"
      :class="{ 'formitem__selected': item.selected }"
      @click="select(idx)">
      {{ item.name }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'FisicalFormSelector',
  data () {
    return {
      list: null
    }
  },
  mounted () {
    this.listLabs()
  },
  methods: {
    async listLabs () {
      const { fisicalForms } = await this.$store.dispatch('Cbpf/LIST_FISICAL_FORMS')
      const mappedList = fisicalForms.map(i => ({
        ...i,
        selected: false
      }))
      this.list = mappedList
    },
    select (idx) {
      this.list[idx].selected = !this.list[idx].selected

      const selectedList = this.list.filter(i => i.selected)
      this.$emit('input', selectedList)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/cbpf/components/fisical-form-selector/FisicalFormSelector.vue